<!-- 
 * @Description: 系统平账（账单） - 后台处理数据临时使用
 * @Author: Niklaus
 * @Date: 2025-03-01 08:45:42
 * @LastEditors: Niklaus
 * @LastEditTime: 2025-03-01 15:49:03
-->
<template>
  <el-container class="h-100p">
    <basic-container style="width: 100%">
      <avue-crud
        ref="table"
        :data="tableData"
        :page.sync="page"
        :option="option"
        :table-loading="tableLoading"
        :search.sync="search"
        @search-change="searchChange"
        @on-load="onLoad"
        @refresh-change="onLoad"
        @selection-change="selectedListChange"
      >
        <template slot-scope="{ size }" slot="menuLeft">
          <el-button icon="el-icon-notebook-1" type="primary" size="small" @click="handleBalance">系统平账</el-button>
        </template>

        <template slot-scope="scope" slot="menu">
          <el-button size="small" @click="openPrefSuppDialog(scope.row.subjectId)">补录优惠减免</el-button>
        </template>
      </avue-crud>
    </basic-container>

    <el-dialog title="优惠补录" :visible.sync="prefSuppDialogVisible" width="40%" append-to-body>
      <el-form v-if="prefSuppDialogVisible" ref="prefSuppForm" :model="prefSuppForm" size="small" label-width="120px">
        <el-form-item
          :rules="[{ required: true, message: '请选择优惠政策', trigger: 'blur' }]"
          label="优惠政策"
          prop="reductionPolicyId"
        >
          <el-select v-model="prefSuppForm.reductionPolicyId" placeholder="请选择优惠政策">
            <el-option
              v-for="item in reducitionList"
              :key="item.reduction_policy_id"
              :label="item.reduction_policy_title"
              :value="item.reduction_policy_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="0px">
          <el-form-item
            :rules="[{ required: true, message: '请输入优惠金额', trigger: 'blur' }]"
            label="优惠金额"
            prop="reductionAmount"
          >
            <el-input
              v-model.number="prefSuppForm.reductionAmount"
              type="number"
              placeholder="请输入优惠金额"
            ></el-input>
          </el-form-item>
          <div class="pull-right">
            <el-button size="small" @click="prefSuppDialogVisible = false">取消</el-button>
            <el-button size="small" @click="savePrefSupp" type="primary">确认</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import { getList, updateReceiptInfo } from "@/api/finance/index.js"
import * as dictService from "@/api/system/dictbiz"
import { additionalAmount } from "@/api/finance/index.js"
import { getMetaCommonList } from "@/api/busiMode/metaCommon"

export default {
  data() {
    return {
      searchOption: {
        contractCode: "",
        receiptNo: "",
      },
      reducitionList: [],
      prefSuppDialogVisible: false,
      prefSuppForm: {},
      model: "wisdom_park.wp_receipt",
      selectedList: [],
      tableLoading: false,
      tableData: [],
      search: {},
      page: {
        pageSizes: this.$store.state.common.pageSizes,
        pagerCount: this.$store.state.common.pagerCount,
        pageSize: 50,
        currentPage: 1,
        total: 0,
      },
      option: {
        height: "auto",
        searchMenuPosition: "right",
        searchMenuSpan: 3,
        searchSpan: 6,
        border: true,
        index: true,
        selection: true,
        delBtn: false,
        editBtn: false,
        addBtn: false,
        menuWidth: 120,
        header: true,
        column: [
          {
            label: "账单对象",
            prop: "subject",
            minWidth: 200,
            search: true,
            searchLike: true,
            searchSpan: 6,
          },
          {
            label: "账单编号",
            prop: "receiptNo",
            width: 180,
            search: true,
            searchLike: true,
            searchSpan: 4,
          },
          {
            label: "关联合同",
            prop: "contractNo",
            minWidth: 150,
            search: true,
            searchLike: true,
            searchSpan: 4,
          },
          {
            label: "类型",
            prop: "feeItemName",
            width: 120,
          },
          {
            label: "账单状态",
            prop: "status",
            type: "select",
            searchSpan: 4,
            search: true,
            dataType: "number",
            dicUrl: dictService.getUrl("ReceiptStatus"),
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            width: 80,
          },
          {
            label: "应收金额",
            prop: "amountReceivable",
            width: 100,
          },
          {
            label: "补贴金额",
            prop: "amountReduction",
            width: 100,
          },
          {
            label: "实收金额",
            prop: "amountReceived",
            width: 100,
          },
          {
            label: "开始时间",
            prop: "periodStartTime",
            width: 100,
            type: "date",
            format: "yyyy-MM-dd",
          },
          {
            label: "结束时间",
            prop: "periodEndTime",
            width: 100,
            type: "date",
            format: "yyyy-MM-dd",
          },

          {
            label: "应缴日期",
            prop: "receivableDate",
            width: 100,
            type: "date",
            format: "yyyy-MM-dd",
          },
        ],
      },
    }
  },

  methods: {
    /**
     * 加载列表数据
     */
    onLoad() {
      this.tableData = []
      let wheres = []
      Object.keys(this.search).forEach((key) => {
        if (this.search[key]) {
          wheres.push({ field: key, value: this.search[key], op: "LIKE" })
        }
      })
      getList({
        current: this.page.currentPage,
        size: this.page.pageSize,
        wheres,
      })
        .then((res) => {
          this.tableData = res.data.data.records
          this.page.total = res.data.data.total
          this.tableLoading = false
        })
        .catch((e) => {
          this.tableLoading = false
        })
    },

    searchChange(params, done) {
      console.log("11111111111111")
      this.onLoad().then((res) => {
        done()
      })
    },
    /**
     * 监听选中的数据列表
     */
    selectedListChange(list) {
      console.log(list)
      this.selectedList = list.map((item) => item.receiptNo)
      this.$nextTick(() => {
        console.log(this.selectedList)
      })
    },
    /**
     * 获取优惠政策列表
     */
    getReducitions(id) {
      getMetaCommonList("wisdom_park.wp_reduction_policy_company", {
        current: 1,
        size: 100,
        wheres: [{ field: "company_id", value: id }],
      }).then((res) => {
        if (res.data && res.data.code === 200) {
          this.reducitionList = res.data.data.records
        }
      })
    },

    /** 打开疫情补录Modal */
    openPrefSuppDialog(id) {
      this.getReducitions(id)
      this.prefSuppDialogVisible = true
    },
    /**
     * 提交优惠减免数据
     */
    savePrefSupp() {
      this.$refs.prefSuppForm.validate((valid) => {
        if (valid) {
          let reductionPolicyName = ""
          this.reducitionList.forEach((e) => {
            if (e.reduction_policy_id == this.prefSuppForm.reductionPolicyId) {
              reductionPolicyName = e.reduction_policy_title
            }
          })
          let obj = {
            reductionPolicyId: this.prefSuppForm.reductionPolicyId, //优惠政策ID
            reductionPolicyName: reductionPolicyName, //优化政策名称
            receiptNo: this.info.receiptNo, //账单编号
            reductionAmount: this.prefSuppForm.reductionAmount, //优惠金额
          }

          additionalAmount(obj).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "操作成功!",
              })
              this.getDetail()
              this.prefSuppDialogVisible = false
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              })
            }
          })
        }
      })
    },

    handleBalance() {
      this.selectedList.length == 0
        ? this.$message.info("至少选择一条数据")
        : this.$confirm("确认系统自动将选中账单平账吗？", "提示", {
            confirmButtonText: "确 认",
            cancelButtonText: "取 消",
          })
            .then(() => {
              this.doBalance()
            })
            .catch(() => console.info("操作取消"))
    },

    doBalance() {
      console.log(" -- 执行系统平账 --")
    },
  },
}
</script>

<style scoped></style>
-->
